(function(){
  'use strict';
  if(window.__mxpCartDrawerV2)return;
  window.__mxpCartDrawerV2=true;

  function one(selector, root){ return (root || document).querySelector(selector); }
  function all(selector, root){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function escapeHtml(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];
    });
  }
  function norm(value){
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }
  function money(cents){
    try {
      return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',minimumFractionDigits:0,maximumFractionDigits:2}).format((Number(cents) || 0) / 100);
    } catch(e){
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  function deviceOf(item){
    var source = norm([item.product_title, item.title, item.handle, item.product_type].filter(Boolean).join(' '));
    if(source.indexOf('macbook') !== -1) return 'mac';
    if(source.indexOf('iphone') !== -1) return 'iphone';
    if(source.indexOf('ipad') !== -1 || source.indexOf('tablet') !== -1 || source.indexOf('tablette') !== -1 || source.indexOf('samsung tab') !== -1) return 'tablet';
    return 'generic';
  }
  function isGift(item){
    var props=item&&item.properties&&typeof item.properties==='object'?item.properties:{};
    return String(props._MAXPROMO_Cadeau||'')==='1';
  }
  function giftCode(item){
    var props=item&&item.properties&&typeof item.properties==='object'?item.properties:{};
    return String(props._MAXPROMO_Code||'').trim();
  }
  function giftRows(item){
    var id=Number(item&&item.variant_id||item&&item.id||0),map={};
    map[58758755385676]=[{label:'Type',value:'Prise secteur'},{label:'Sortie',value:'USB-A · 2A'},{label:'Contenu',value:'1 prise secteur'}];
    map[58758754763084]=[{label:'Connectique',value:'USB-A → Lightning'},{label:'Compatibilité',value:'iPhone et iPad avec port Lightning'},{label:'Contenu',value:'1 câble'}];
    map[58969799426380]=[{label:'Connectique',value:'USB-A → USB-C'},{label:'Compatibilité',value:'Smartphones et tablettes USB-C'},{label:'Contenu',value:'1 câble'}];
    map[59005547315532]=[{label:'Connectique',value:'MagSafe L'},{label:'Compatibilité',value:'Anciens MacBook compatibles MagSafe L'},{label:'Contenu',value:'1 chargeur'}];
    map[59005547741516]=[{label:'Connectique',value:'MagSafe T'},{label:'Compatibilité',value:'MacBook compatibles MagSafe T'},{label:'Contenu',value:'1 chargeur'}];
    map[59005548003660]=[{label:'Connectique',value:'USB-C'},{label:'Compatibilité',value:'MacBook USB-C et Apple Silicon'},{label:'Contenu',value:'1 chargeur'}];
    map[59005664854348]=[{label:'Connectique',value:'Apple 30 broches'},{label:'Compatibilité',value:'Anciens iPhone et iPad compatibles'},{label:'Contenu',value:'1 chargeur'}];
    map[59005665116492]=[{label:'Connectique',value:'Micro-USB'},{label:'Compatibilité',value:'Anciens Samsung et Android compatibles'},{label:'Contenu',value:'1 chargeur'}];
    return map[id]||[{label:'Type',value:'Accessoire compatible'}];
  }
  function giftPriceHtml(item){
    var qty=Math.max(1,Number(item&&item.quantity)||1);
    var original=Number(item&&item.original_line_price||0);
    if(!original){
      var unit=Number(item&&item.original_price||item&&item.price||0);
      if(unit>0)original=unit*qty;
    }
    var crossed=original>0?'<del style="color:#8a9098;font-size:.82em;font-weight:700;margin-right:6px">'+escapeHtml(money(original))+'</del>':'';
    return crossed+'<strong style="color:#111216;font-weight:950">0 €</strong>';
  }
  function isRepair(item){
    if(isGift(item))return false;
    var source = norm([item.product_title, item.title, item.handle, item.product_type].filter(Boolean).join(' '));
    var props = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var hasRepairProp = Object.keys(props).some(function(key){
      var k = norm(key);
      return k.indexOf('reparation') !== -1 || k.indexOf('panne') !== -1 || k.indexOf('modele') !== -1;
    });
    return hasRepairProp || source.indexOf('reparat') !== -1 || source.indexOf('repair-checkout') !== -1 || source.indexOf('reparation technique') !== -1;
  }
  function kindOf(name){
    var n = norm(name);
    if(/couleur|color|colour/.test(n)) return 'color';
    if(/processeur|processor|puce|chip/.test(n)) return 'processor';
    if(/(^|\s)ram($|\s)|memoire|memory/.test(n)) return 'ram';
    if(/capacite|capacity|stockage|storage/.test(n)) return 'storage';
    if(/connect|reseau|network|wifi|wi-fi|cellular/.test(n)) return 'connectivity';
    if(/etat|condition|grade|esthetique/.test(n)) return 'condition';
    if(/batterie|battery/.test(n)) return 'battery';
    return 'other';
  }
  function labelFor(kind, device, fallback){
    if(kind === 'color') return 'Couleur';
    if(kind === 'processor') return 'Processeur';
    if(kind === 'ram') return 'RAM';
    if(kind === 'storage') return device === 'mac' ? 'Stockage' : 'Capacité';
    if(kind === 'connectivity') return 'Connectivité';
    if(kind === 'condition') return 'État';
    if(kind === 'battery') return 'Batterie';
    return fallback || 'Option';
  }
  function rank(kind, device){
    var maps = {
      mac:{color:10,processor:20,ram:30,storage:40,condition:50,battery:60,connectivity:70,other:900},
      iphone:{color:10,storage:20,condition:30,battery:40,connectivity:50,processor:60,ram:70,other:900},
      tablet:{color:10,storage:20,connectivity:30,condition:40,battery:50,processor:60,ram:70,other:900},
      generic:{color:10,processor:20,ram:30,storage:40,connectivity:50,condition:60,battery:70,other:900}
    };
    return (maps[device] || maps.generic)[kind] || 900;
  }
  function looksLikeCondition(value){ return /mini prix|bon etat|tres bon|comme neuf|correct|grade\s*[a-f]/.test(norm(value)); }
  function looksLikeBattery(value){ return /batterie|battery|80\s*[-–]\s*89|90\s*[-–]\s*99|100\s*%|standard|performante|neuve/.test(norm(value)); }
  function looksLikeConnectivity(value){ return /wifi|wi-fi|4g|5g|lte|cellular|cellulaire/.test(norm(value)); }
  function looksLikeStorage(value){ return /\b\d+\s*(go|gb|to|tb)\b/i.test(String(value || '')); }
  function looksLikeColor(value){ return /argent|gris sideral|space gr[ae]y|minuit|midnight|lumiere stellaire|starlight|bleu ciel|sky blue|noir|black|blanc|white|rose|pink|rouge|red|vert|green|bleu|blue|or|gold|violet|purple|titane|titanium/.test(norm(value)); }
  function parseConfiguration(value, device){
    var s = String(value || '').trim();
    var out = [];
    if(!s) return out;
    var proc = s.match(/Apple\s+(?:M|A)\d+(?:\s+(?:Pro|Max|Ultra))?/i);
    if(proc){
      var before = s.slice(0, proc.index).replace(/[|·,:;\-–—]+\s*$/, '').trim();
      if(before) out.push({kind:'color',label:'Couleur',value:before});
      out.push({kind:'processor',label:'Processeur',value:proc[0].trim()});
      var rest = s.slice(proc.index + proc[0].length).replace(/^\s*[|·,:;\-–—]+\s*/, '').trim();
      var tokens = rest.split(/\s*\|\s*/).map(function(v){return v.trim();}).filter(Boolean);
      var memoryTokens = tokens.filter(function(v){return looksLikeStorage(v);});
      if(memoryTokens[0]) out.push({kind:'ram',label:'RAM',value:memoryTokens[0]});
      if(memoryTokens[1]) out.push({kind:'storage',label:'Stockage',value:memoryTokens[1]});
      tokens.forEach(function(v){
        if(memoryTokens.indexOf(v) !== -1) return;
        if(looksLikeBattery(v)) out.push({kind:'battery',label:'Batterie',value:v});
        else if(looksLikeCondition(v)) out.push({kind:'condition',label:'État',value:v});
      });
      return out;
    }
    var dash = s.match(/^(.+?)\s+[\-–—]\s+(.+)$/);
    if(dash && looksLikeConnectivity(dash[2])){
      out.push({kind:'storage',label:labelFor('storage',device),value:dash[1].trim()});
      out.push({kind:'connectivity',label:'Connectivité',value:dash[2].trim()});
      return out;
    }
    if(looksLikeStorage(s) && looksLikeConnectivity(s)){
      var conn = s.match(/(?:Wi[ -]?Fi(?:\s*\+\s*(?:4G|5G|LTE))?|4G|5G|LTE|Cellular|Cellulaire)/i);
      if(conn){
        var storage = s.replace(conn[0], '').replace(/[|·,:;\-–—]+\s*$/, '').trim();
        if(storage) out.push({kind:'storage',label:labelFor('storage',device),value:storage});
        out.push({kind:'connectivity',label:'Connectivité',value:conn[0].trim()});
        return out;
      }
    }
    return [{kind:'other',label:'Configuration',value:s}];
  }
  function pushRow(rows, seen, row, device){
    if(!row || !String(row.value || '').trim()) return;
    row.kind = row.kind || kindOf(row.label);
    row.label = labelFor(row.kind, device, row.label);
    row.value = String(row.value).trim();
    row._seq = rows.length;
    if(row.kind !== 'other'){
      if(seen[row.kind]) return;
      seen[row.kind] = true;
    } else {
      var key = norm(row.label) + '|' + norm(row.value);
      if(seen[key]) return;
      seen[key] = true;
    }
    rows.push(row);
  }
  function addNamedValue(rows, seen, name, value, device){
    if(value == null || String(value).trim() === '') return;
    var n = norm(name);
    if(n === 'configuration' || n.indexOf('configuration') !== -1){
      parseConfiguration(value, device).forEach(function(row){ pushRow(rows, seen, row, device); });
      return;
    }
    var kind = kindOf(name);
    if(kind === 'storage'){
      var dash = String(value).match(/^(.+?)\s+[\-–—]\s+(.+)$/);
      if(dash && looksLikeConnectivity(dash[2])){
        pushRow(rows, seen, {kind:'storage',label:labelFor('storage',device),value:dash[1]}, device);
        pushRow(rows, seen, {kind:'connectivity',label:'Connectivité',value:dash[2]}, device);
        return;
      }
    }
    pushRow(rows, seen, {kind:kind,label:name,value:value}, device);
  }
  function inferUnnamed(value, device){
    var s = String(value || '').trim();
    if(!s || norm(s) === 'default title') return null;
    var parsed = parseConfiguration(s, device);
    if(parsed.length > 1 || (parsed[0] && parsed[0].kind !== 'other')) return parsed;
    if(looksLikeBattery(s)) return [{kind:'battery',label:'Batterie',value:s}];
    if(looksLikeCondition(s)) return [{kind:'condition',label:'État',value:s}];
    if(looksLikeConnectivity(s)) return [{kind:'connectivity',label:'Connectivité',value:s}];
    if(looksLikeStorage(s)) return [{kind:'storage',label:labelFor('storage',device),value:s}];
    if(looksLikeColor(s)) return [{kind:'color',label:'Couleur',value:s}];
    return null;
  }
  function normalRows(item){
    if(isGift(item))return giftRows(item);
    var device = deviceOf(item), rows = [], seen = {};
    var opts = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    opts.forEach(function(opt){ addNamedValue(rows, seen, opt.name || '', opt.value, device); });
    if(!opts.length && Array.isArray(item.variant_options)){
      item.variant_options.forEach(function(value){
        var inferred = inferUnnamed(value, device);
        if(inferred) inferred.forEach(function(row){ pushRow(rows, seen, row, device); });
      });
    }
    var props = item.properties && typeof item.properties === 'object' ? item.properties : {};
    Object.keys(props).forEach(function(key){
      var value = props[key];
      if(!key || key.charAt(0) === '_' || value == null || String(value).trim() === '') return;
      var nk = norm(key);
      if(nk === 'tarif' || nk.indexOf('tarif') === 0) return;
      addNamedValue(rows, seen, key, value, device);
    });
    rows.sort(function(a,b){ var d = rank(a.kind,device) - rank(b.kind,device); return d || a._seq - b._seq; });
    return rows;
  }
  function repairInfo(item){
    var out={model:'',fault:'',power:'',mode:'',imei:'',notes:''};
    var props = item.properties && typeof item.properties === 'object' ? item.properties : {};
    Object.keys(props).forEach(function(key){
      var value=props[key];
      if(value == null || String(value).trim()==='') return;
      var k=norm(key), v=String(value).trim();
      if(k === 'modele' || k.indexOf('modele') !== -1) out.model=v;
      else if(k.indexOf('reparation') !== -1 || k.indexOf('panne') !== -1) out.fault=v;
      else if(k.indexOf('allumage') !== -1) out.power=v;
      else if(k.indexOf('prise en charge') !== -1 || k.indexOf('mode de prise') !== -1) out.mode=v;
      else if(k === 'imei' || k.indexOf('imei') !== -1) out.imei=v;
      else if(k.indexOf('precision') !== -1 || k.indexOf('description') !== -1 || k.indexOf('note') !== -1) out.notes=v;
    });
    return out;
  }
  function repairMetaHtml(info){
    var bits=[];
    if(info.power) bits.push('<span class="mxp-repair-detail"><b>Appareil</b>'+escapeHtml(info.power)+'</span>');
    if(info.mode){
      var mode=/envoi a distance/i.test(norm(info.mode)) ? 'À distance · Mondial Relay / Chronopost' : info.mode;
      bits.push('<span class="mxp-repair-detail"><b>Envoi</b>'+escapeHtml(mode)+'</span>');
    }
    if(info.imei) bits.push('<span class="mxp-repair-detail"><b>IMEI</b>'+escapeHtml(info.imei)+'</span>');
    if(info.notes) bits.push('<span class="mxp-repair-detail mxp-repair-detail--wide"><b>Précisions</b>'+escapeHtml(info.notes)+'</span>');
    return bits.join('');
  }
  function mediaHtml(item, repair){
    if(repair){
      return '<div class="mxp-drawer-media mxp-drawer-media--service" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a4 4 0 0 0-5-5L7.5 3 9 4.5 7 6.5 5.5 5 3.8 6.7a4 4 0 0 0 5 5l7.9 7.9a2 2 0 1 0 2.8-2.8l-7.8-7.8"></path><path d="m13.5 6.5 4-4"></path></svg></div>';
    }
    var img = item.featured_image && (item.featured_image.url || item.featured_image.src);
    if(!img && item.image){ img = typeof item.image === 'string' ? item.image : (item.image.url || item.image.src); }
    if(img) return '<div class="mxp-drawer-media"><img src="'+escapeHtml(img)+'" alt="'+escapeHtml(item.product_title || item.title || 'Produit')+'" loading="lazy"></div>';
    return '<div class="mxp-drawer-media mxp-drawer-media--empty" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4" y="4" width="16" height="16" rx="3"></rect><path d="m7 16 3.5-4 2.5 3 2-2 2 3"></path><circle cx="9" cy="9" r="1"></circle></svg></div>';
  }
  function repairEditUrl(){
    var u='/pages/reparation-iphone';
    try{
      var p=new URLSearchParams(location.search), preview=p.get('preview_theme_id');
      if(preview) u+='?preview_theme_id='+encodeURIComponent(preview);
    }catch(e){}
    return u;
  }
  function renderLine(item){
    var repair = isRepair(item);
    var qty = Number(item.quantity) || 1;
    var linePrice = item.final_line_price != null ? item.final_line_price : ((item.final_price || item.price || 0) * qty);
    if(repair){
      var info=repairInfo(item);
      var repairTitle='Réparation '+(info.model || 'iPhone');
      var fault=info.fault || 'Intervention sélectionnée';
      return '<article class="mxp-drawer-line mxp-drawer-line--repair" data-mxp-line data-key="'+escapeHtml(item.key)+'">'+
        mediaHtml(item,true)+
        '<div class="mxp-drawer-content">'+
          '<div class="mxp-drawer-top"><div class="mxp-drawer-main"><span class="mxp-drawer-badge">Réparation</span><a class="mxp-drawer-title" href="'+escapeHtml(repairEditUrl())+'">'+escapeHtml(repairTitle)+'</a><div class="mxp-repair-fault">'+escapeHtml(fault)+'</div></div><strong class="mxp-drawer-price">'+escapeHtml(money(linePrice))+'</strong></div>'+
          '<div class="mxp-repair-details">'+repairMetaHtml(info)+'</div>'+
          '<div class="mxp-drawer-actions mxp-drawer-actions--repair"><span class="mxp-repair-unit">1 appareil</span><span class="mxp-repair-action-links"><a class="mxp-repair-edit" href="'+escapeHtml(repairEditUrl())+'">Modifier</a><button type="button" class="mxp-drawer-remove" data-mxp-remove>Supprimer</button></span></div>'+
        '</div></article>';
    }
    var gift=isGift(item);
    var rows = normalRows(item);
    var meta = rows.map(function(row){ return '<div class="mxp-drawer-meta-row"><b>'+escapeHtml(row.label)+' :</b><span>'+escapeHtml(row.value)+'</span></div>'; }).join('');
    var title = item.product_title || item.title || 'Produit';
    var url = item.url || '#';
    var promo = gift && giftCode(item) ? '<div data-mxp-gift-note="1" class="mxp-drawer-gift-note" style="display:inline-flex;align-items:center;gap:6px;width:max-content;max-width:100%;margin-top:7px;padding:6px 9px;border-radius:8px;background:#eaf9ee;color:#13a047;font-size:9.5px;font-weight:800;line-height:1.25">🎁 <span>Offert grâce au code promo <strong style="font-weight:950">'+escapeHtml(giftCode(item).toUpperCase())+'</strong></span></div>' : '';
    var price = gift ? giftPriceHtml(item) : escapeHtml(money(linePrice));
    var actions = gift
      ? '<span style="display:inline-flex;align-items:center;min-height:28px;padding:0 9px;border:1px solid #e3e6e9;border-radius:9px;background:#fafafa;color:#555d66;font-size:9px;font-weight:800">Quantité '+qty+' · offerte</span>'
      : '<div class="qty" aria-label="Quantité"><button type="button" data-mxp-qty="-1" aria-label="Diminuer">−</button><input type="number" value="'+qty+'" readonly aria-label="Quantité"><button type="button" data-mxp-qty="1" aria-label="Augmenter">+</button></div><button type="button" class="mxp-drawer-remove" data-mxp-remove>Supprimer</button>';
    return '<article class="mxp-drawer-line" data-mxp-line data-key="'+escapeHtml(item.key)+'"'+(gift?' data-mxp-promo-gift="1"':'')+'>'+
      mediaHtml(item,false)+
      '<div class="mxp-drawer-content">'+
        '<div class="mxp-drawer-top"><div class="mxp-drawer-main"><a class="mxp-drawer-title" href="'+escapeHtml(url)+'">'+escapeHtml(title)+'</a>'+promo+'</div><strong class="mxp-drawer-price">'+price+'</strong></div>'+
        (meta?'<div class="mxp-drawer-meta">'+meta+'</div>':'')+
        '<div class="mxp-drawer-actions">'+actions+'</div>'+
      '</div></article>';
  }
  function updateHeaderCount(count){
    all('[data-cart-count], .cart-count').forEach(function(el){ el.textContent = count; if(count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden','hidden'); });
  }
  function draw(cart){
    var lines = one('[data-drawer-lines]'), empty = one('[data-drawer-empty]'), foot = one('[data-drawer-foot]'), total = one('[data-drawer-total]'), countEl = one('[data-mxp-drawer-count]');
    if(!lines) return;
    var items = Array.isArray(cart.items) ? cart.items : [];
    lines.innerHTML = items.map(renderLine).join('');
    var count = Number(cart.item_count) || 0;
    if(countEl) countEl.textContent = count ? (count + (count > 1 ? ' articles' : ' article')) : '0 article';
    if(total) total.textContent = money(cart.total_price || 0);
    if(empty) empty.hidden = count > 0;
    if(foot) foot.hidden = count === 0;
    lines.hidden = count === 0;
    updateHeaderCount(count);
    var drawer = one('#CartDrawer');
    if(drawer) drawer.setAttribute('data-mxp-cart-ready','1');
  }
  function refresh(){
    return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(function(cart){ draw(cart); polishMainCart(); return cart; })
      .catch(function(){ var drawer=one('#CartDrawer'); if(drawer) drawer.setAttribute('data-mxp-cart-ready','1'); return null; });
  }
  function change(key, quantity){
    return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})})
      .then(function(r){ if(!r.ok) throw new Error('change'); return r.json(); })
      .then(function(cart){
        if(window.MXPPromoGift&&typeof window.MXPPromoGift.reconcile==='function'){
          return window.MXPPromoGift.reconcile(cart);
        }
        return cart;
      })
      .then(function(cart){
        draw(cart);
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart,mxpPromoReconciled:true}}));
        if(document.body.classList.contains('template-cart')){
          window.location.reload();
        }
        return cart;
      })
      .catch(function(){ return refresh(); });
  }
  function injectPolishStyles(){
    if(document.getElementById('mxp-repair-cart-polish')) return;
    var style=document.createElement('style');
    style.id='mxp-repair-cart-polish';
    style.textContent=''+
      '#CartDrawer .mxp-drawer-line--repair{grid-template-columns:64px minmax(0,1fr)!important;padding:14px!important;border:1px solid #ead67d!important;border-left:4px solid #ffc400!important;background:#fff!important;box-shadow:0 5px 18px rgba(17,18,22,.045)!important}'+
      '#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media{width:58px!important;height:58px!important;border:0!important;border-radius:14px!important;background:#ffc400!important}'+
      '#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media svg{width:26px!important;height:26px!important;stroke-width:1.9!important}'+
      '#CartDrawer .mxp-drawer-line--repair .mxp-drawer-badge{margin-bottom:6px!important;padding:4px 7px!important;font-size:7.7px!important;letter-spacing:.08em!important}'+
      '#CartDrawer .mxp-drawer-line--repair .mxp-drawer-title{font-size:15px!important;font-weight:950!important;line-height:1.18!important;letter-spacing:-.02em!important}'+
      '#CartDrawer .mxp-repair-fault{margin-top:3px;color:#4f5660;font-size:11.5px;font-weight:850;line-height:1.3}'+
      '#CartDrawer .mxp-repair-details{display:flex;flex-wrap:wrap;gap:6px;margin-top:9px}'+
      '#CartDrawer .mxp-repair-detail{display:inline-flex;align-items:center;gap:4px;max-width:100%;padding:5px 7px;border:1px solid #eceef1;border-radius:8px;background:#f8f9fa;color:#666d76;font-size:9.5px;line-height:1.25}'+
      '#CartDrawer .mxp-repair-detail b{color:#252a30;font-weight:900}'+
      '#CartDrawer .mxp-repair-detail--wide{flex-basis:100%;white-space:normal}'+
      '#CartDrawer .mxp-drawer-actions--repair{padding-top:11px!important;border-top:1px solid #f0f1f3!important;margin-top:10px!important}'+
      '#CartDrawer .mxp-repair-unit{display:inline-flex;align-items:center;min-height:27px;padding:0 9px;border-radius:999px;background:#fff7d7;color:#5e4a00;font-size:9px;font-weight:900}'+
      '#CartDrawer .mxp-repair-action-links{display:flex;align-items:center;gap:13px}'+
      '#CartDrawer .mxp-repair-edit{color:#30343a;font-size:10px;font-weight:850;text-decoration:underline;text-decoration-color:#c8ccd1;text-underline-offset:3px}'+
      '#CartDrawer .mxp-repair-edit:hover{color:#111;text-decoration-color:#111}'+
      '#CartDrawer .mxp-drawer-line--repair .mxp-drawer-price{font-size:16px!important}'+
      '[data-mxp3] .mxp3line.mxp3line--repair-polished{grid-template-columns:70px minmax(0,1fr) auto;border:1px solid #e6d78d;border-left:4px solid #ffc400;background:#fff;box-shadow:0 5px 18px rgba(17,18,22,.035)}'+
      '[data-mxp3] .mxp3line--repair-polished .mxp3serviceicon{width:62px;height:62px;border:0;border-radius:14px;background:#ffc400;color:#111}'+
      '[data-mxp3] .mxp3line--repair-polished .mxp3serviceicon svg{width:27px;height:27px;stroke-width:1.9}'+
      '[data-mxp3] .mxp3line--repair-polished .mxp3name{font-size:15px;font-weight:950;letter-spacing:-.02em}'+
      '[data-mxp3] .mxp3line--repair-polished .mxp3badge{background:#111;color:#fff;border-radius:999px;padding:5px 8px;font-size:8px}'+
      '[data-mxp3] .mxp3-repair-fault{margin-top:4px;color:#4f5660;font-size:11.5px;font-weight:850}'+
      '[data-mxp3] .mxp3-repair-details{display:flex;flex-wrap:wrap;gap:6px;margin-top:9px}'+
      '[data-mxp3] .mxp3-repair-detail{display:inline-flex;gap:4px;padding:5px 7px;border:1px solid #eceef1;border-radius:8px;background:#f8f9fa;color:#666d76;font-size:9.5px;line-height:1.25}'+
      '[data-mxp3] .mxp3-repair-detail b{color:#252a30}'+
      '[data-mxp3] .mxp3-repair-detail--wide{flex-basis:100%}'+
      '[data-mxp3] .mxp3line--repair-polished .mxp3actions{padding-top:10px;border-top:1px solid #f0f1f3;justify-content:flex-start}'+
      '[data-mxp3] .mxp3-repair-unit-main{display:inline-flex;align-items:center;min-height:28px;padding:0 9px;border-radius:999px;background:#fff7d7;color:#5e4a00;font-size:9px;font-weight:900}'+
      '[data-mxp3] .mxp3-repair-edit-main{color:#30343a;font-size:9.5px;font-weight:850;text-decoration:underline;text-decoration-color:#c8ccd1;text-underline-offset:3px}'+
      '@media(max-width:650px){#CartDrawer .mxp-drawer-line--repair{grid-template-columns:56px minmax(0,1fr)!important}#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media{width:52px!important;height:52px!important}[data-mxp3] .mxp3line.mxp3line--repair-polished{grid-template-columns:58px minmax(0,1fr)}[data-mxp3] .mxp3line--repair-polished .mxp3serviceicon{width:52px;height:52px}[data-mxp3] .mxp3line--repair-polished .mxp3price{grid-column:2;grid-row:2;justify-self:end}}';
    document.head.appendChild(style);
  }
  function mainRepairInfo(line){
    var info={model:'',fault:'',power:'',mode:'',imei:'',notes:''};
    all('.mxp3attr',line).forEach(function(row){
      var l=one('span',row), v=one('strong',row); if(!l||!v) return;
      var k=norm(l.textContent), val=v.textContent.trim();
      if(k.indexOf('modele')!==-1) info.model=val;
      else if(k.indexOf('reparation')!==-1 || k.indexOf('panne')!==-1) info.fault=val;
      else if(k.indexOf('allumage')!==-1) info.power=val;
      else if(k.indexOf('prise en charge')!==-1 || k.indexOf('mode de prise')!==-1) info.mode=val;
      else if(k.indexOf('imei')!==-1) info.imei=val;
      else if(k.indexOf('precision')!==-1 || k.indexOf('description')!==-1) info.notes=val;
    });
    return info;
  }
  function mainRepairDetailsHtml(info){
    var bits=[];
    if(info.power) bits.push('<span class="mxp3-repair-detail"><b>Appareil</b>'+escapeHtml(info.power)+'</span>');
    if(info.mode){ var mode=/envoi a distance/i.test(norm(info.mode)) ? 'À distance · Mondial Relay / Chronopost' : info.mode; bits.push('<span class="mxp3-repair-detail"><b>Envoi</b>'+escapeHtml(mode)+'</span>'); }
    if(info.imei) bits.push('<span class="mxp3-repair-detail"><b>IMEI</b>'+escapeHtml(info.imei)+'</span>');
    if(info.notes) bits.push('<span class="mxp3-repair-detail mxp3-repair-detail--wide"><b>Précisions</b>'+escapeHtml(info.notes)+'</span>');
    return bits.join('');
  }
  function polishMainCart(){
    injectPolishStyles();
    all('[data-mxp3] .mxp3line').forEach(function(line){
      if(!one('.mxp3serviceicon',line)) return;
      if(line.dataset.mxpRepairPolish==='2') return;
      line.dataset.mxpRepairPolish='2';
      line.classList.add('mxp3line--repair-polished');
      var info=mainRepairInfo(line);
      var name=one('.mxp3name',line); if(name) name.textContent='Réparation '+(info.model||'iPhone');
      var badge=one('.mxp3badge',line); if(badge) badge.textContent='Réparation';
      var top=one('.mxp3topline',line);
      if(top && !one('.mxp3-repair-fault',line)) top.insertAdjacentHTML('afterend','<div class="mxp3-repair-fault">'+escapeHtml(info.fault||'Intervention sélectionnée')+'</div>');
      var attrs=one('.mxp3attrs',line);
      if(attrs) attrs.outerHTML='<div class="mxp3-repair-details">'+mainRepairDetailsHtml(info)+'</div>';
      var icon=one('.mxp3serviceicon',line);
      if(icon) icon.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a4 4 0 0 0-5-5L7.5 3 9 4.5 7 6.5 5.5 5 3.8 6.7a4 4 0 0 0 5 5l7.9 7.9a2 2 0 1 0 2.8-2.8l-7.8-7.8"></path><path d="m13.5 6.5 4-4"></path></svg>';
      var actions=one('.mxp3actions',line);
      if(actions){
        var qty=one('.mxp3qty',actions); if(qty) qty.remove();
        if(!one('.mxp3-repair-unit-main',actions)) actions.insertAdjacentHTML('afterbegin','<span class="mxp3-repair-unit-main">1 appareil</span><a class="mxp3-repair-edit-main" href="'+escapeHtml(repairEditUrl())+'">Modifier</a>');
      }
    });
  }

  document.addEventListener('click',function(event){
    var openButton = event.target.closest && event.target.closest('[data-panel-open="CartDrawer"]');
    if(openButton){
      var liveDrawer=one('#CartDrawer');
      if(liveDrawer&&liveDrawer.getAttribute('data-mxp-cart-ready')!=='1')setTimeout(refresh,0);
      return;
    }
    var drawer = event.target.closest && event.target.closest('#CartDrawer');
    if(!drawer) return;
    var qtyButton = event.target.closest('[data-mxp-qty]');
    var removeButton = event.target.closest('[data-mxp-remove]');
    if(!qtyButton && !removeButton) return;
    var line = event.target.closest('[data-mxp-line]'); if(!line) return;
    var key = line.getAttribute('data-key');
    var input = one('.qty input',line);
    var current = input ? (parseInt(input.value,10) || 1) : 1;
    if(removeButton) change(key,0); else change(key,current + (parseInt(qtyButton.getAttribute('data-mxp-qty'),10) || 0));
  });
  document.addEventListener('cart:refresh',refresh);
  document.addEventListener('cart:updated',function(event){
    var cart=event&&event.detail&&event.detail.cart;
    if(cart){draw(cart);polishMainCart();}
  });
  var mxpCartBooted=false;
  function mxpCartBoot(){
    if(mxpCartBooted)return;
    mxpCartBooted=true;
    injectPolishStyles();
    polishMainCart();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mxpCartBoot,{once:true});
  else mxpCartBoot();
  window.addEventListener('pageshow',function(event){
    if(event&&event.persisted){
      injectPolishStyles();
      polishMainCart();
    }
  });
})();
